import { Box, Grid, Typography, Avatar } from "../../../imports/muiImport";
import {
  useEffect,
  useState,
  useDispatch,
  useSelector,
} from "../../../imports/generalImport";

import { fetchUserProfile } from "../../../store/userProfile/action";
import { useAuth } from "../../../hooks/contexts/AuthContext";
import { WalletHold } from "../../../apiCalls/urlFunction";

const UserProfile = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.UserProfile?.allData);

  const { isLoggedIn } = useAuth();

  const [loading, setLoading] = useState(true);
  const [holdAmount, setHoldAmount] = useState({
    holdAmount: 0,
    availableAmount: 0,
  });

  const getWallet = async () => {
    try {
      const response = await WalletHold();
      setHoldAmount({
        holdAmount: Number(response?.data?.holdAmount || 0),
        availableAmount: Number(response?.data?.availableAmount || 0),
      });
    } catch (error) {
    }
  };

  useEffect(() => {
    if (!user && isLoggedIn) {
      dispatch(fetchUserProfile());
    } else {
      setLoading(false);
    }
    getWallet();
  }, [dispatch, user, isLoggedIn]);

  const profileData = [
    {
      label: "Name",
      value: user?.firstName || "N/A",
    },
    {
      label: "Email",
      value: user?.email || "N/A",
    },
    {
      label: "Wallet Balance",
      value: `${user?.currency || "AED"} ${user?.walletDatum?.amount || "0"}`,
    },
    {
      label: "Wallet Hold Balance",
      value: `${user?.currency || "AED"} ${holdAmount?.holdAmount || "0"}`,
    },
  ];

  return (
    <Box
      sx={{
        border: "1px solid #eee",
        borderRadius: 3,
        p: { xs: 2, sm: 3 },
        background: "#fff",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 3,
          flexDirection: { xs: "column", sm: "row" },
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        <Avatar
          sx={{
            width: { xs: 60, sm: 70 },
            height: { xs: 60, sm: 70 },
            bgcolor: "primary.main",
            fontFamily: "Be Vietnam Pro",
            fontWeight: 500,
          }}
        >
          {user?.firstName
            ?.split(" ")
            .filter(Boolean)
            .slice(0, 2)
            .map((word) => word.charAt(0))
            .join("")
            .toUpperCase() || "U"}
        </Avatar>

        <Box>
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "18px" },
              fontWeight: 600,
            }}
          >
            {loading ? "Loading..." : user?.firstName}
          </Typography>
        </Box>
      </Box>

      {/* GRID SECTION */}
      <Grid container spacing={2}>
        {profileData.map((item, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Box>
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#888",
                  fontFamily: "Be Vietnam Pro",
                  fontWeight: 500,
                }}
              >
                {item.label}
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: "13px", sm: "14px" },
                  fontFamily: "Be Vietnam Pro",
                  fontWeight: 500,
                  mt: 0.5,
                  wordBreak: "break-word",
                }}
              >
                {loading ? "..." : item.value}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default UserProfile;
